import { createTheme } from "@mui/material";
import t from "../../theme";

export const theme = createTheme({
  typography: {
    fontFamily: t.font.family,
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          background: "transparent",
          borderBottom: "1px solid rgba(46, 125, 50, 0.08)",
          boxShadow: "none",
          minHeight: "38px",
          padding: "0 12px",
        }),
        indicator: {
          height: "2.5px",
          borderRadius: "3px 3px 0 0",
          background: "linear-gradient(90deg, #2e7d32 0%, #43a047 100%)",
          boxShadow: "0 0 6px rgba(46, 125, 50, 0.3)",
        },
        flexContainer: {
          gap: "4px",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          color: ownerState.selected ? "#2e7d32 !important" : "#666",
          textTransform: "none",
          fontWeight: ownerState.selected ? 600 : 450,
          fontSize: "0.84rem",
          cursor: "pointer",
          minHeight: "38px",
          padding: "6px 16px",
          borderRadius: "8px 8px 0 0",
          transition: "all 0.2s ease",
          position: "relative",
          overflow: "visible",
          letterSpacing: "0.15px",
          "&:hover": {
            backgroundColor: "rgba(46, 125, 50, 0.05)",
            color: "#2e7d32",
          },
          "&.Mui-selected": {
            background: "rgba(255, 255, 255, 0.75)",
            boxShadow: "0 -1px 3px rgba(46, 125, 50, 0.06)",
            borderTop: "1px solid rgba(46, 125, 50, 0.08)",
            borderLeft: "1px solid rgba(46, 125, 50, 0.08)",
            borderRight: "1px solid rgba(46, 125, 50, 0.08)",
            borderBottom: "none",
          },
        }),
      },
    },
  },
});
